import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "expanded", "onExpandedChange", "expandedDefault", "selectionMode", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ToggleGroup } from '@snack-uikit/toggles';
import { extractSupportProps } from '@snack-uikit/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function Accordion(_ref) {
  var children = _ref.children,
    expanded = _ref.expanded,
    onExpandedChange = _ref.onExpandedChange,
    expandedDefault = _ref.expandedDefault,
    _ref$selectionMode = _ref.selectionMode,
    selectionMode = _ref$selectionMode === void 0 ? 'single' : _ref$selectionMode,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _jsx(ToggleGroup, {
      value: expanded,
      defaultValue: expandedDefault,
      onChange: onExpandedChange,
      selectionMode: selectionMode,
      children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
        className: className
      }, extractSupportProps(rest)), {}, {
        children: children
      }))
    })
  );
}